import { Flex, FlexItem, Title } from '@patternfly/react-core'
import { useCallback } from 'react'
import * as React from 'react'

import { SmallButton } from '@app/utils/styles/small-button'

interface Props {
  onSelectPatient: () => void
}

export const SelectPatientCard = ({ onSelectPatient }: Props) => {
  const handleSelectPatient = useCallback(() => {
    onSelectPatient()
  }, [onSelectPatient])

  return (
    <Flex direction={{ default: 'column' }}>
      <FlexItem>
        <Flex direction={{ default: 'row' }}>
          <FlexItem>
            <Title headingLevel="h2" size="lg">
              Patient Information
            </Title>
          </FlexItem>
          <FlexItem>
            <SmallButton
              style={{ marginRight: 5 }}
              key="cancel"
              variant="secondary"
              isSmall
              onClick={handleSelectPatient}
            >
              Select Patient
            </SmallButton>
          </FlexItem>
        </Flex>
      </FlexItem>
    </Flex>
  )
}
